// src/utils/previewGenerator.js
export const generatePreviewHTML = (data) => {
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return `Escrito el ${date.toLocaleDateString('es-ES', {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    })}`;
  };

  // Función para detectar el tipo de video y obtener el embed correcto
  const getVideoEmbed = (videoUrl, videoType) => {
    if (!videoUrl) return null;
    
    if (videoType === 'youtube' || videoUrl.includes('youtube.com') || videoUrl.includes('youtu.be')) {
      // Si ya es un embed, usarlo directamente
      if (videoUrl.includes('/embed/')) {
        return videoUrl;
      }
      // Convertir URL normal de YouTube a embed
      const videoId = videoUrl.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([^&\n?#]+)/);
      return videoId ? `https://www.youtube.com/embed/${videoId[1]}` : videoUrl;
    }
    
    if (videoType === 'vimeo' || videoUrl.includes('vimeo.com')) {
      // Si ya es un embed, usarlo directamente  
      if (videoUrl.includes('player.vimeo.com')) {
        return videoUrl;
      }
      // Convertir URL normal de Vimeo a embed
      const videoId = videoUrl.match(/vimeo\.com\/([0-9]+)/);
      return videoId ? `https://player.vimeo.com/video/${videoId[1]}` : videoUrl;
    }
    
    // Para MP4 o URLs directas, devolver la URL tal como está
    return videoUrl;
  };

  const renderVideo = () => {
    if (!data.hasVideo || !data.videoUrl) return '';

    const embedUrl = getVideoEmbed(data.videoUrl, data.videoType);
    const isDirectVideo = data.videoType === 'mp4' || data.videoUrl.includes('.mp4');

    if (isDirectVideo) {
      return `
        <div style="margin: 24px auto; max-width: 800px;">
          <div style="background: #000; border-radius: 12px; overflow: hidden; box-shadow: 0 4px 12px rgba(0,0,0,0.15);">
            <video width="100%" height="240" controls ${data.videoThumbnail ? `poster="${data.videoThumbnail}"` : ''} style="width: 100%;">
              <source src="${data.videoUrl}" type="video/mp4">
              Tu navegador no soporta la reproducción de video.
            </video>
          </div>
          <div style="text-align: center; margin-top: 12px;">
            <span style="font-size: 13px; color: #666; font-weight: 500;">Video del artículo</span>
          </div>
        </div>
      `;
    } else {
      return `
        <div style="margin: 24px auto; max-width: 800px;">
          <div style="background: #000; border-radius: 12px; overflow: hidden; box-shadow: 0 4px 12px rgba(0,0,0,0.15);">
            <div style="position: relative; padding-bottom: 56.25%; height: 0;">
              <iframe 
                src="${embedUrl}" 
                frameborder="0" 
                allowfullscreen 
                title="Video del artículo"
                style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;"
              ></iframe>
            </div>
          </div>
          <div style="text-align: center; margin-top: 12px;">
            <span style="font-size: 13px; color: #666; font-weight: 500;">Video del artículo</span>
          </div>
        </div>
      `;
    }
  };

  const renderAudio = () => {
    if (!data.hasAudio || !data.audioUrl) return '';
    
    return `
      <div id="audioPlayer" style="background: #f8f9fa; margin: 20px auto; padding: 16px; border-radius: 12px; box-shadow: 0 2px 8px rgba(220, 53, 69, 0.3); border: 1px solid rgba(220, 53, 69, 0.1); max-width: 500px;">
        <audio id="audioElement" src="${data.audioUrl}" preload="metadata"></audio>
        
        <!-- Barra de progreso -->
        <div style="margin-bottom: 16px; position: relative;">
          <div id="progressBar" style="width: 100%; height: 6px; background: rgba(220, 53, 69, 0.2); border-radius: 3px; cursor: pointer; position: relative;">
            <div id="progressFill" style="width: 0%; height: 100%; background: #dc3545; border-radius: 3px; transition: width 0.1s ease;"></div>
            <div id="progressThumb" style="position: absolute; top: 50%; left: 0%; transform: translate(-50%, -50%); width: 16px; height: 16px; background: #dc3545; border-radius: 50%; border: 2px solid white; box-shadow: 0 2px 4px rgba(220, 53, 69, 0.3); cursor: pointer; opacity: 0;"></div>
          </div>
          <div style="display: flex; justify-content: space-between; margin-top: 8px; font-size: 12px; color: #666;">
            <span id="currentTime">0:00</span>
            <span id="duration">Cargando...</span>
          </div>
        </div>

        <!-- Controles -->
        <div style="display: flex; justify-content: center; align-items: center; gap: 20px;">
          <button id="skipBackward" style="width: 44px; height: 44px; border-radius: 50%; border: 2px solid #dc3545; background: transparent; color: #dc3545; cursor: pointer; display: flex; align-items: center; justify-content: center; font-size: 12px; font-weight: bold; transition: all 0.2s ease;" disabled>-10</button>
          <button id="playPauseBtn" style="width: 56px; height: 56px; border-radius: 50%; border: none; background: #dc3545; color: white; cursor: pointer; display: flex; align-items: center; justify-content: center; font-size: 20px; transition: transform 0.1s ease; box-shadow: 0 4px 12px rgba(220, 53, 69, 0.3);" disabled>
            <svg id="playIcon" width="20" height="20" viewBox="0 0 24 24" fill="none" style="margin-left: 2px;">
              <path d="M8 5v14l11-7z" fill="white" stroke="white" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <svg id="pauseIcon" width="20" height="20" viewBox="0 0 24 24" fill="none" style="display: none;">
              <rect x="6" y="4" width="4" height="16" fill="white" rx="1"/>
              <rect x="14" y="4" width="4" height="16" fill="white" rx="1"/>
            </svg>
            <div id="loadingSpinner" style="width: 20px; height: 20px; border: 2px solid transparent; border-top: 2px solid white; border-radius: 50%; animation: spin 1s linear infinite;"></div>
          </button>
          <button id="skipForward" style="width: 44px; height: 44px; border-radius: 50%; border: 2px solid #dc3545; background: transparent; color: #dc3545; cursor: pointer; display: flex; align-items: center; justify-content: center; font-size: 12px; font-weight: bold; transition: all 0.2s ease;" disabled>+10</button>
        </div>
      </div>
    `;
  };

  return `
    <!DOCTYPE html>
    <html lang="es">
    <head>
      <meta charset="UTF-8">
      <meta name="viewport" content="width=device-width, initial-scale=1.0, user-scalable=no">
      <title>Vista Previa - ${data.title}</title>
      <style>
        * { 
          margin: 0; 
          padding: 0; 
          box-sizing: border-box; 
        }
        body { 
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
          background: #f0f2f5;
          color: white;
          min-height: 100vh;
          overflow-x: hidden;
          padding: 20px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        
        /* Simulación del móvil */
        .mobile-container {
          width: 414px;
          height: 896px;
          margin: 0 auto;
          background: linear-gradient(135deg, #2c3e50 0%, #34495e 100%);
          position: relative;
          box-shadow: 0 8px 40px rgba(0,0,0,0.3);
          border-radius: 25px;
          overflow-y: auto;
          overflow-x: hidden;
        }
        
        /* Header rojo de la app */
        .app-header {
          background: linear-gradient(135deg, #e62c19 0%, #a01916 100%);
          height: 120px;
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;
          padding-top: 20px;
          flex-shrink: 0;
        }
        
        .back-button {
          position: absolute;
          left: 16px;
          top: 50%;
          transform: translateY(-50%);
          width: 40px;
          height: 40px;
          background: rgba(255,255,255,0.2);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-size: 18px;
        }
        
        .search-button {
          position: absolute;
          right: 16px;
          top: 50%;
          transform: translateY(-50%);
          width: 40px;
          height: 40px;
          background: rgba(255,255,255,0.2);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-size: 18px;
        }
        
        .section-title {
          color: white;
          font-size: 22px;
          font-weight: 600;
          text-align: center;
        }
        
        /* Animación para el spinner */
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
        
        /* Hero section con imagen de fondo */
        .hero-section {
          height: 280px;
          background-image: ${data.imageUrl ? `url('${data.imageUrl}')` : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'};
          background-size: cover;
          background-position: center;
          position: relative;
          display: flex;
          flex-direction: column;
          justify-content: flex-end;
          padding: 24px;
        }
        
        .hero-overlay {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: linear-gradient(transparent 0%, rgba(0,0,0,0.7) 100%);
        }
        
        .hero-content {
          position: relative;
          z-index: 2;
        }
        
        .article-title {
          font-size: 22px;
          font-weight: 700;
          color: white;
          margin-bottom: 12px;
          line-height: 1.3;
          text-shadow: 0 2px 4px rgba(0,0,0,0.5);
        }
        
        .article-meta {
          font-size: 14px;
          color: rgba(255,255,255,0.9);
          margin-bottom: 8px;
        }
        
        .article-author {
          font-size: 16px;
          color: white;
          font-weight: 500;
        }
        
        /* Contenido principal */
        .content-section {
          background: white;
          margin-top: -20px;
          border-radius: 20px 20px 0 0;
          padding: 32px 24px 40px;
          position: relative;
          z-index: 3;
          min-height: calc(100vh - 400px);
        }
        
        .content-title {
          text-align: center;
          font-size: 18px;
          font-weight: 600;
          color: #333;
          margin-bottom: 8px;
        }
        
        .content-subtitle {
          text-align: center;
          font-size: 14px;
          color: #666;
          margin-bottom: 32px;
          white-space: pre-wrap;
        }
        
        .article-content {
          color: #333;
          font-size: 16px;
          line-height: 1.7;
        }
        
        .article-content h1, 
        .article-content h2, 
        .article-content h3 {
          color: #2c3e50;
          margin: 24px 0 16px;
          font-weight: 600;
        }
        
        .article-content p {
          margin-bottom: 16px;
        }
        
        .article-content blockquote {
          border-left: 4px solid #d4524f;
          padding-left: 16px;
          margin: 20px 0;
          font-style: italic;
          background: #f8f9fa;
          padding: 16px;
          border-radius: 8px;
        }
        
        .article-content img {
          width: 100%;
          border-radius: 12px;
          margin: 20px 0;
        }
        
        .article-content ul, 
        .article-content ol {
          padding-left: 20px;
          margin-bottom: 16px;
        }
        
        .article-content li {
          margin-bottom: 8px;
        }
        
        /* Responsive */
        @media (max-width: 375px) {
          .mobile-container {
            width: 100vw;
          }
          
          .hero-section {
            height: 250px;
            padding: 20px;
          }
          
          .article-title {
            font-size: 20px;
          }
          
          .content-section {
            padding: 24px 20px 100px;
          }
        }
      </style>
    </head>
    <body>
      <div class="mobile-container">
        
        <!-- Header de la app -->
        <div class="app-header">
          <div class="back-button">←</div>
          <div class="section-title">${data.section || 'General'}</div>
          <div class="search-button">🔍</div>
        </div>
        
        <!-- Hero section con imagen -->
        <div class="hero-section">
          <div class="hero-overlay"></div>
          <div class="hero-content">
            <h1 class="article-title">${data.title}</h1>
            <div class="article-meta">${formatDate(data.date)}</div>
            <div class="article-author">${data.author}</div>
          </div>
        </div>
        
        <!-- Contenido principal -->
        <div class="content-section">
          ${data.subtitle ? `
            <div class="content-title">${data.author}</div>
            <div class="content-subtitle">${data.subtitle}</div>
          ` : `
            <div class="content-title">Texto: ${data.author}</div>
          `}
          
          ${renderAudio()}
          ${renderVideo()}
          
          <div class="article-content">
            ${data.content}
          </div>
        </div>
        
      </div>
      
      <script>
        // Reproductor de audio completo
        const audio = document.getElementById('audioElement');
        
        if (audio) {
          const playPauseBtn = document.getElementById('playPauseBtn');
          const playIcon = document.getElementById('playIcon');
          const pauseIcon = document.getElementById('pauseIcon');
          const loadingSpinner = document.getElementById('loadingSpinner');
          const skipBackward = document.getElementById('skipBackward');
          const skipForward = document.getElementById('skipForward');
          const progressBar = document.getElementById('progressBar');
          const progressFill = document.getElementById('progressFill');
          const progressThumb = document.getElementById('progressThumb');
          const currentTimeEl = document.getElementById('currentTime');
          const durationEl = document.getElementById('duration');
          
          let isPlaying = false;
          let duration = 0;
          
          // Formatear tiempo
          function formatTime(seconds) {
            if (isNaN(seconds) || seconds === 0) return "0:00";
            const mins = Math.floor(seconds / 60);
            const secs = Math.floor(seconds % 60);
            return mins + ':' + (secs < 10 ? '0' : '') + secs;
          }
          
          // Cuando se carga la metadata
          audio.addEventListener('loadedmetadata', function() {
            duration = audio.duration;
            durationEl.textContent = formatTime(duration);
            
            // Habilitar controles
            playPauseBtn.disabled = false;
            skipBackward.disabled = false;
            skipForward.disabled = false;
            
            // Mostrar botón play/pause
            loadingSpinner.style.display = 'none';
            playIcon.style.display = 'block';
            progressThumb.style.opacity = '1';
          });
          
          // Actualizar progreso
          audio.addEventListener('timeupdate', function() {
            const currentTime = audio.currentTime;
            const progress = (currentTime / duration) * 100;
            
            currentTimeEl.textContent = formatTime(currentTime);
            progressFill.style.width = progress + '%';
            progressThumb.style.left = progress + '%';
          });
          
          // Al terminar
          audio.addEventListener('ended', function() {
            isPlaying = false;
            playIcon.style.display = 'block';
            pauseIcon.style.display = 'none';
            audio.currentTime = 0;
          });
          
          // Play/Pause
          playPauseBtn.addEventListener('click', function() {
            if (isPlaying) {
              audio.pause();
              isPlaying = false;
              playIcon.style.display = 'block';
              pauseIcon.style.display = 'none';
            } else {
              audio.play();
              isPlaying = true;
              playIcon.style.display = 'none';
              pauseIcon.style.display = 'block';
            }
          });
          
          // Retroceder 10s
          skipBackward.addEventListener('click', function() {
            audio.currentTime = Math.max(0, audio.currentTime - 10);
          });
          
          // Adelantar 10s
          skipForward.addEventListener('click', function() {
            audio.currentTime = Math.min(duration, audio.currentTime + 10);
          });
          
          // Click en barra de progreso
          progressBar.addEventListener('click', function(e) {
            if (duration) {
              const rect = progressBar.getBoundingClientRect();
              const clickX = e.clientX - rect.left;
              const newTime = (clickX / rect.width) * duration;
              audio.currentTime = newTime;
            }
          });
          
          // Hover effects para botones
          skipBackward.addEventListener('mouseenter', function() {
            this.style.background = '#dc3545';
            this.style.color = 'white';
          });
          skipBackward.addEventListener('mouseleave', function() {
            this.style.background = 'transparent';
            this.style.color = '#dc3545';
          });
          
          skipForward.addEventListener('mouseenter', function() {
            this.style.background = '#dc3545';
            this.style.color = 'white';
          });
          skipForward.addEventListener('mouseleave', function() {
            this.style.background = 'transparent';
            this.style.color = '#dc3545';
          });
          
          playPauseBtn.addEventListener('mousedown', function() {
            this.style.transform = 'scale(0.95)';
          });
          playPauseBtn.addEventListener('mouseup', function() {
            this.style.transform = 'scale(1)';
          });
          playPauseBtn.addEventListener('mouseleave', function() {
            this.style.transform = 'scale(1)';
          });
        }
      </script>
    </body>
    </html>
  `;
};